// extracted by mini-css-extract-plugin
module.exports = {"fontCompactaCom":"giveaway-fonts_fontCompactaCom__zP_5W"};